import { LitElement, html } from 'lit';
import styles from './fit-move-top.css';

class FitMoveTop extends LitElement {
  static get is() { return 'fit-move-top'; }

  static get styles() { return styles; }

  render() {
    return html``;
  }

  static get properties() {
    return {
      ticking: {
        type: Boolean,
      },
      loaded: {
        type: Boolean,
      },
      windowHeight: {
        type: Number,
      },
    };
  }

  constructor(props) {
    super(props);
    this.ticking = false;
    this.loaded = false;
    this.windowHeight = 0;
    this.init = this.init.bind(this);
    this.requestTick = this.requestTick.bind(this);
    this.checkVisibility = this.checkVisibility.bind(this);
    this.updateWindowInformation = this.updateWindowInformation.bind(this);
    this.checkVisibility();
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();
    window.addEventListener('resize', this.updateWindowInformation);
    window.addEventListener('load', this.init, false);
    document.addEventListener('DOMContentLoaded', this.init, false);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  checkVisibility() {
    window.pageYOffset > this.windowHeight * 2
      ? this.setAttribute('visible', '') : this.removeAttribute('visible');
    this.ticking = false;
  }

  handleClick(event) {
    event.preventDefault();
    this.scrollToPageTop(document.querySelector('body'), 500);
  }

  init() {
    if (!this.loaded) {
      this.updateWindowInformation();
      this.checkVisibility();
      window.addEventListener('scroll', this.requestTick);
    }
  }

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(this.checkVisibility);
      this.ticking = true;
    }
  }

  scrollToPageTop(destination, duration = 200, easing = 'linear', callback) {
    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
    const documentHeight = Math.max(document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight
                         || document.documentElement.clientHeight
                         || document.getElementsByTagName('body')[0].clientHeight;
    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll);
      if (callback) {
        callback();
      }
      return;
    }

    function scroll() {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, ((now - startTime) / duration));
      window.scroll(0, Math.ceil((time * (destinationOffsetToScroll - start)) + start));

      if (window.pageYOffset === destinationOffsetToScroll) {
        if (callback) {
          callback();
        }
        return;
      }
      requestAnimationFrame(scroll);
    }
    scroll();
  }

  updateWindowInformation() {
    this.windowHeight = window.innerHeight;
  }
}

customElements.define(FitMoveTop.is, FitMoveTop);
